import { render, staticRenderFns } from "./registrazione.vue?vue&type=template&id=468578ba&"
import script from "./registrazione.vue?vue&type=script&lang=js&"
export * from "./registrazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports